import { Vendor } from "../CRUDs/entities/Vendor";
import errors from "../errors";
var Mustache = require('mustache');
import masks from '../masks'
var getMessagesProgress = false;
var getUsersProgress = false;
import { Validator } from "../snippets/Validator";
import daterangepicker from "../daterangepicker";
import { JobRequest } from "../CRUDs/entities/JobRequest";
import conversationSelection from "./conversation_selection";

const validation_fields = [
    'email',
    'phone',
    'first_name',
    'last_name',
    'address',
    'city',
    'state',
    'zip_code',
]
const vendor_validation_fields = [
    'email',
    'phone',
    'vendor_name',
    'address',
    'zip_code'
];

export default {

    numValue:'+1 ',

    init() {

        if ($('#chat-messages').length) {
            this.normalizeDaySplits();
            this.scrollMessageBottom();
            this.sendMessage();
            this.userFullSearch();
            this.doneMessages();
        }
        if (!window.location.pathname.match(/\/cockpit.{0,1}$/)) {
            $('#follow-ups').show();
        }

        if(window.location.pathname.match('/phone-') || window.location.pathname.match('/email-')){
            if (window.location.pathname.match('/email-'))
                this.showOnlyEmailSubmitButtons();
            if (window.location.pathname.match('/phone-'))
                this.showOnlyPhoneSubmitButtons();
            this.replaceFollowUps(true)
            this.replaceIncidents(null,false)
            $('#contact-options-modal .add-follow-up').addClass('d-none')
            $('#contact-options-modal .follow-ups-btn').addClass('d-none')
            $('#contact-options-modal .mobile-link-orders').addClass('d-none')
        }

        if($('input[name=customer_id]').val()!='') //Временный фикс для Subject
            $(`.chat[data-id="${$('input[name=customer_id]').val()}"]`).trigger('click')

        //this.getCurrentUser(this);
        this.numpadInit()
        this.loadMessagesOnScroll();
        this.getUserInfoModal();
        this.getUserInfoEditModal();
        this.updateUser();
        this.getForwardModal();
        this.getMetaInfo();
        this.forwardEmail();

        this.getTemplatesModal();
        this.getCreateTemplateModal();
        this.createTemplate();
        this.getEditTemplateModal();
        this.saveTemplate();
        this.insertTemplate();
        this.deleteTemplate();

        this.getFollowUpsModalAdd();
        this.getFollowUpsModalEdit();
        this.createFollowUp();

        this.showConnectPad();
        this.checkUser();

        this.getContactOptionsModal();
        this.blockContact();
        this.markAsLead();
        this.markAsSpam();

        this.saveContactToCustomer();

        this.messagesSettingsModal();
        this.breakEmailChain();

        this.showForwardButtons();

        this.enterDialPadNumber();
        this.showCarbonCopiesModal();

        this.newJobRequest();
        this.spamReview();
        conversationSelection.init();
        this.markSpamMessage();


        this.getEmailAdditionalInfoModal();
        if (window.innerWidth > 1024) {
            this.trackCreateIncidentModal();
            this.trackEditIncidentModal();
        }

        if (window.innerWidth < 1024) {
            const path = window.location.pathname;
            if (path.startsWith('/cockpit/phone-')) {
                const phone = decodeURIComponent(path.replace('/cockpit/phone-', ''));
                $('#connect-phone').val(phone);
                $('#connect-chat').click();
            } else if (path.startsWith('/cockpit/email-')) {
                const email = decodeURIComponent(path.replace('/cockpit/email-', ''));
                $('#connect-email').val(email);
                $('#connect-chat').click();
            }
        }
        // Защита от дурака, если пытается выйти из Cockpit
        //TODO: Больше не имеет смысла т.к. на сайте подключены пуши
        /*if(!/^popup-cockpit/.test(window.name))
            window.onbeforeunload = function (e) {

                let cockpit_reload_flag = localStorage.getItem('cockpit_reload_flag');
                let message = 'Warning! You are currently on call and trying to close the page. It will result in a dropped call.';

                console.log('cockpit_reload_flag: ' + cockpit_reload_flag);
                if (cockpit_reload_flag === 'true') {
                    localStorage.setItem('cockpit_reload_flag', 'false');
                    delete e['returnValue'];
                } else {

                    console.log(message, e, window.event);

                    e = e || window.event;

                    // For IE and Firefox
                    if (e) {
                        e.returnValue = message;
                    }

                    // For Safari
                    return message;
                }
            };*/

        $('.cockpit-call-phone').removeClass('d-none');
        $('.cockpit-forwarding-phone').addClass('d-none');

        // setTimeout(function () {
        //     $('#call-toggle').click();
        // }, 1000 * 5);

        if (settings['call_forwarding_phone']) {
            $('.cockpit-call-phone').addClass('d-none');
            $('.cockpit-forwarding-phone').removeClass('d-none');
        }
        if (cockpit_default_subject && !$.trim($('.cockpit-subject-input-hidden').val())) {
            $('.cockpit-subject-input-value').attr('placeholder', cockpit_default_subject);
            $('.cockpit-subject-input-value').val(cockpit_default_subject);
            $('.cockpit-subject-input-hidden').val(cockpit_default_subject);
        }

        // $('body').on('click', '.container-chat #subscriptions', function (e) { //ЗДЕСЬ КЛИК ПО SUBSCRIPTIONS
        //     window.open('/subscription', '_blank').focus();
        // });

        // change status in Order Receipt
        $('body').on('click', '.change-status', function (e) {

            e.preventDefault();
            let data = $(this).data();
            let order_id = data.order_id;

            $.ajax({
                type: 'GET',
                url: '/order_status',
                data: {
                    "order_id" : order_id,
                    "type": "action-list",
                },
                success: function (response) {
                    $('#change_status_modal_info').html(response);
                    $('#order_status_modal').css('z-index', 1060);
                    $('#order_status_modal').modal('show');
                }
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        });

        $('body').on('keyup', '.cockpit-subject-input-value', function(e) {
            e.preventDefault();
            const $subject = $('.cockpit-subject-input-value');
            const value = $.trim($subject.val());
            const threadSubject = $.trim($subject.attr('data-thread-subject'));
            const continuesThread = threadSubject.length > 0 && value === threadSubject;
            $('#cockpit-subject-checkbox-input').prop('checked', !continuesThread);
            $('.cockpit-subject-input-hidden').val(value);
            if (!continuesThread) $('.cockpit-reply-message-id').val('');
        });

        $('body').on('change', '#cockpit-subject-checkbox-input', function() {
            const $subject = $('.cockpit-subject-input-value');
            const threadSubject = $.trim($subject.attr('data-thread-subject'));
            const defaultSubject = $.trim($subject.attr('data-default-subject'));
            const subject = this.checked ? defaultSubject : (threadSubject || $.trim($subject.val()));
            $subject.val(subject);
            $('.cockpit-subject-input-hidden').val(subject);
            if (this.checked) $('.cockpit-reply-message-id').val('');
        });

        return this;
    },

    scrollMessageBottom() {
        let chatMessages = document.querySelector('.messages-cockpit-content');
        if (!chatMessages) {
            return;
        }

        let firstUnread = chatMessages.querySelector('.new-messages');
        if (firstUnread) {
            let unreadEvent = firstUnread.closest('.message');
            let top = unreadEvent ? unreadEvent.offsetTop : firstUnread.offsetTop;
            chatMessages.scrollTop = Math.max(0, top - chatMessages.offsetTop - 20);
            return;
        }

        chatMessages.scrollTop = chatMessages.scrollHeight;
    },
    sendMessage() {
        let $this = this;
        $('body').on('click', '#chat-messages .send', function (e) {
            e.preventDefault();
            let id = $('.sending')[0].id;
            $('#status_message').html('<div class="alert alert-info">Sending message...</div>');
            let form = $(this).closest('form')[0];
            let data = new FormData(form);
            if (id === 'org_send_chat' || id === 'org_send_email') {
                let subjectInput = $('.cockpit-subject-input-value');
                let subject = $.trim(subjectInput.val())
                    || $.trim(subjectInput.attr('placeholder'))
                    || $.trim($('.cockpit-subject-input-hidden').val());
                data.set('subject', subject);
                $('.cockpit-subject-input-hidden').val(subject);
            }
            data.append('carbon_copies', $('#cc_list').val());
            $.ajax({
                type: 'POST',
                enctype: 'multipart/form-data',
                url: '/cockpit/' + id,
                data: data,
                processData: false,
                contentType: false,
                success: function () {
                    $('#chat-messages textarea').val('');
                    let last_message = $('.last_message').last().text();
                    $this.sendDone(last_message);
                    $('#status_message').html('<div class="alert alert-success">Sending message is successful</div>');
                    $('#attachments').html('');
                    $('#attach_input').val('');
                    $this.clearCCForm();
                    // setTimeout(function () {
                    //     $this.scrollMessageBottom();
                    // }, 500);
                },
                error: function (response) {
                    let errors = '<div class="alert alert-danger"><ul>';
                    $.each(response.responseJSON.errors, function (index, value) {
                        errors += '<li>' + value + '</li>';
                    });
                    errors += '</ul></div>';
                    $('#status_message').html(errors);
                },
                complete: function () {
                    setTimeout(function () {
                        // $this.scrollMessageBottom();
                        $('#status_message').html('');
                    }, 1000 * 5);
                    $('#message').countSms('#sms-counter');
                }
            });
        })
    },
    getMessages(curr_id = null, click = null, older_message_time = null, from = '', typeUser=null) {
        // console.log('call getMessages( ' + curr_id + ', ' + click + ', ' + older_message_time + ')' + (new Error()).stack);

        let uriPathNameParsed = window.location.pathname.split('/');

        if (older_message_time != null) {
            if ($('.is_empty_mesasges').length > 0) return;
        }

        $('#loading-center').show();
        if(window.innerWidth<1024)
            $('#loading-left').show();
        if (!getMessagesProgress) {
            getMessagesProgress = true
            let $this = this;
            let last_message = null;
            if (! curr_id && ! older_message_time) {
                last_message = $('.last_message').last().text();
            }
            let customer_id = $("input[name=customer_id]").val();
            if ($(click).find('.chat-title.a').length > 0) {
                customer_id = click.id;
            }
            $.ajax({
                type: 'POST',
                url: '/cockpit/org-get-messages/' + window.organisation_id,
                data: ({
                    phone: $("#send-form input[name=phone]").val() ? $("#send-form input[name=phone]").val() : $(click).data('user_phone'),
                    email: $("#send-form input[name=email]").val() ? $("#send-form input[name=email]").val() : $(click).data('user_email'),
                    customer_id: customer_id,
                    last_message: last_message,
                    older_message_time: older_message_time,
                    type: typeUser
                }),
                success: function (response) {
                    $('#loading-center').hide();
                    if (click) {
                        $this.replaceCountNewMessages(click);
                    }else{
                        $this.replaceCountNewMessages();
                    }
                    if (curr_id) {
                        $('#chat-messages #messages').html(response);
                        $this.normalizeDaySplits();
                    }else if(older_message_time){
                        let old_height = document.querySelector('.messages-cockpit-content').scrollHeight;
                        $('#messages').prepend(response);
                        $this.normalizeDaySplits();
                        let new_height = document.querySelector('.messages-cockpit-content').scrollHeight;
                        $('.messages-cockpit-content').scrollTop(new_height-old_height);
                        return;
                    }else{
                        $('#chat-messages #messages').append(response);
                        $this.normalizeDaySplits();
                    }

                    if (response != '') {
                        setTimeout(function () {
                            $this.scrollMessageBottom();
                        }, 500);
                    }
                },
                complete: function () {
                    $('#loading-center').hide();
                    setTimeout(function () {
                        getMessagesProgress = false;
                        if(window.innerWidth<1024)
                            $('#loading-left').hide();
                    }, 500);
                }
            }).fail(function (jqXHR, exception) {
                $('#loading-center').hide();
                if(window.innerWidth<1024)
                    $('#loading-left').hide();
                getMessagesProgress = false;
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        }else{
            $('#loading-center').hide();
        }
    },
    normalizeDaySplits() {
        const seenDays = new Set();

        $('#messages > .day-split[data-day]').each(function () {
            const day = String($(this).attr('data-day') || '');
            if (!day) {
                return;
            }

            if (seenDays.has(day)) {
                $(this).remove();
                return;
            }

            seenDays.add(day);
        });
    },
    doneMessages() {
        let $this = this;
        $('body').on('click', '.send_done', function(e) {
            e.preventDefault();
            let message = $(this).closest('.message')[0];
            let last = $($(message).find('.last_message')[0]).text();
            $this.sendDone(last, message);
        });
    },
    sendDone(last, message = null) {
        let $this = this;
        $.ajax({
            type: 'POST',
            url: '/cockpit/org-done-messages/' + window.organisation_id,
            data: ({
                last_message: last,
                customer_id: $($('.user_data')[0]).data('id'),
                phone: $("#chat-input-form input[name=phone]").val() ? $("#chat-input-form input[name=phone]").val() : $($('.user_data')[0]).data('user_phone'),
                email: $("#chat-input-form input[name=email]").val() ? $("#chat-input-form input[name=email]").val() : $($('.user_data')[0]).data('user_email'),
                entity_type: $('#send-form input[name=type]').val()
            }),
            success: function (response) {
                $this.getMessages();
                $this.getUsers();
                $('.new-messages').remove();
                if($(message).attr('id') != $('#messages .message').last().attr('id'))
                    $(message).append($('#new_message').html());
                let date_this_message = new Date(last);
                $('.ready').each(function(i, el) {
                    let this_message = $($(el).closest('.message')[0]);
                    let this_date = $(this_message.find('.last_message')[0]);
                    let date_el = new Date(this_date.text());
                    if (date_el.getTime() <= date_this_message.getTime()) {
                        $(el).text('Done');
                        $($(this_message).find('.send_done')).remove();
                        $($(this_message).find('.reader')[0]).text($('#reader').text());
                    }
                });
            },
        }).fail(function (jqXHR, exception) {
            if (jqXHR.status == 403) {
                localStorage.setItem('cockpit_reload_flag', true);
                window.location.reload();
            }
        });
    },
    loadMessagesOnScroll() {
        let $this = this;
        console.log('INIT SCROLL')
        $('.messages-cockpit-content').on('scroll', function () {
            let older_message_time = $('.last_message').first().text();
            let in_progress = false;
            let table = $('.messages-cockpit-content');
            if (table.scrollTop() == 0 && !in_progress) {
                in_progress = true;
                $this.getMessages(null, null, older_message_time, '');
                in_progress = false;
            }
        });
    },
    getUsers(curr_id = null) {
        if (getUsersProgress === false) {
            getUsersProgress = true;
            $('#loading-left').show();

            $.ajax({
                type: 'POST',
                url: '/cockpit/org-get-users/' + window.organisation_id,
                data: ({
                    current_phone: $("#chat-input-form input[name=phone]").val(),
                    current_email: $("#chat-input-form input[name=email]").val(),
                    user_name: $('input[name="first_name"]').val()+' '+$('input[name="last_name"]').val(),
                    letters: $('#user_full_search').val(),
                    chat_select: $('input[name="chat_select"]:checked').val(),
                }),
                success: function (response) {

                    let oldText = $('#chat-messages #users').text().replaceAll(" ","").replaceAll("\r","").replaceAll("\n","");
                    let newText = $(response).text().replaceAll(" ","").replaceAll("\r","").replaceAll("\n","");

                    if (oldText != newText) {
                        $('#chat-messages #users').html(response);
                    }

                    if (curr_id) {
                        $('.chat').each(function (i, el) {
                            $(el).find('.chat-content').removeClass('open')
                            $(el).removeClass('active')
                            if (el.id == curr_id) {
                                $(el).addClass('active')
                                $(el).find('.chat-content').addClass('open');
                            }
                        });
                    }

                    document.title = window.blinkTitle;

                    $.ajax({
                        type: 'POST',
                        url: '/cockpit/org-get-count-new-messages',
                        success: function (response) {
                            $('#new_customers').text(response.users);
                            $('#new_not_customers').text(response.not_customers);
                            //$('#new_incidents').text(response.incidents);
                            $('#new_vendors').text(response.vendors);
                            //$('#new_customers_with_incidents').text(response.messages_users_with_incidents);
                            $('.chat-count-new').each(function(i,el) {
                                if ($(el).text() == 0) {
                                    $(el).hide();
                                }else{
                                    $(el).show();
                                }
                            });

                            let messageTitleCount = response.users + response.not_customers;

                            document.title = window.blinkTitle + ' (' + messageTitleCount + ')';
                            $('#loading-left').hide();
                        }
                    }).fail(function (jqXHR, exception) {
                        $('#loading-left').hide();
                        if (jqXHR.status == 403) {
                            localStorage.setItem('cockpit_reload_flag', true);
                            window.location.reload();
                        }
                    });
                },
                complete: function() {
                    setTimeout(function () {
                        getUsersProgress = false;
                    }, 500);
                }
            }).fail(function (jqXHR, exception) {
                $('#loading-left').hide();
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        }
    },
    restoreRightSidebar() {
        const sidebar = $('.right-sidebar');
        const previous = sidebar.data('previous-content');
        if (previous !== undefined) {
            sidebar.html(previous);
            sidebar.removeData('previous-content'); // опционально очищаем
        }
        $('.cockpit-wrapper').show()
    },
    getCurrentUser(from_this) {
        let $this = this;
        if ($(from_this).data('id')) {
            $.ajax({
                type: 'POST',
                url: '/cockpit/org-get-current-user/' + window.organisation_id,
                data: ({
                    id: $(from_this).data('id'),
                    type: $(from_this).data('type')
                }),
                success: function (response) {
                    console.log(response);
                    $this.restoreRightSidebar();
                    $this.replaceCurrentUser(from_this, response)
                    $this.clearCCForm();
                }
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        }
    },
    replaceCurrentUser(from_this, response) {
        let $this = this;
        $("input[name=phone]").val(response.phone);
        $("input[name=email]").val(response.email);
        let hideFollowUp = false;
        let hideFiles = true
        let files = [];
        console.log('RESPONSE TYPE: ', response.type)

        // The composer is persistent while conversations load over AJAX. Keep
        // customer-only channels synchronized with the newly selected entity.
        const isCustomer = response.type === 'customer';
        const chatAvailable = isCustomer && [true, 1, '1'].includes(response.chat_available);
        $('#org_send_chat_wrap').toggleClass('d-none', !isCustomer);
        $('#org_send_chat')
            .toggleClass('is-locked', isCustomer && !chatAvailable)
            .attr('aria-disabled', String(!chatAvailable));
        if (isCustomer && !chatAvailable) {
            $('#org_send_chat').attr('data-bb-popover-toggle', '');
        } else {
            $('#org_send_chat').removeAttr('data-bb-popover-toggle');
            $('#org_send_chat_wrap .bb-popover').removeClass('open');
        }
        if (!chatAvailable) {
            $('#org_send_chat').removeClass('btn-primary sending').addClass('btn-light');
            $('#send-form').removeClass('portal-chat-mode');
        }

        if (response.type == 'vendor') {
            hideFiles = false;
            hideFollowUp = true
            files = response.files;
        }
        if(!response?.type)
            hideFollowUp = true

        $this.replaceIncidents(response.incidents, hideFollowUp);
        $this.replaceOrders(response.orders, response.type=='customer');
        $this.replaceJobs(response.jobs, response.type=='customer', response.org_local_id);
        $this.replaceSubscriptions(response.subscriptions, response.org_local_id);
        $this.replaceUserInfo(response);
        $this.replaceFollowUps(hideFollowUp);
        $this.replaceVendorFiles(files,hideFiles, response.id);
        console.log('RESPONSE: ', response)
        const nextSubject = response.email_subject || $('.cockpit-subject-input-value').attr('data-default-subject') || '';
        $('.cockpit-subject-input-value')
            .val(nextSubject)
            .attr('data-thread-subject', response.is_new_thread ? '' : nextSubject);
        $('.cockpit-subject-input-hidden').val(nextSubject);
        $('.cockpit-reply-message-id').val('');
        $('#cockpit-subject-checkbox-input').prop('checked', response.is_new_thread);

        //$this.getUsers();
        $this.getMessages($(from_this).data('id'), from_this,null,null, $('#send-form input[name="type"]').val());
        $this.syncAvailableSubmitButtons(from_this, chatAvailable);

        if ($('input[name="chat_select"]:checked').val() == 'Customers'){
            $('#contact-options-modal .add-follow-up').removeClass('d-none')
            $('#contact-options-modal .follow-ups-btn').removeClass('d-none')
            $('#contact-options-modal .mobile-link-orders').removeClass('d-none')
        }else{
            $('#contact-options-modal .add-follow-up').addClass('d-none')
            $('#contact-options-modal .follow-ups-btn').addClass('d-none')
            $('#contact-options-modal .mobile-link-orders').addClass('d-none')
        }

        if($('input[name="chat_select"]:checked').val() == 'Other'){
            $('#contact-options-modal #mark-spam-contact').removeClass('d-none')
        }else{
            $('#contact-options-modal #mark-spam-contact').addClass('d-none')
        }


        /*let vh100 = window.innerHeight;
        if (window.innerWidth < 1024) {
            if ($('#send-form input[name=email]').val() == '') {
                $('#chat-messages #messages').css('height', 'calc(' + vh100 + 'px - 375px + 90px)');
            } else {
                $('#chat-messages #messages').css('height', 'calc(' + vh100 + 'px - 375px)');
            }
        } else {
            if ($('#send-form input[name=email]').val() == '') {
                $('#chat-messages #messages').css('height', 'calc(' + vh100 + 'px - 315px + 85px)');
            } else {
                $('#chat-messages #messages').css('height', 'calc(' + vh100 + 'px - 315px)');
            }
        }*/

        setTimeout(function() {
            if (window.innerWidth < 1024) {

                $('#cockpit-leads-link').hide();

                // if ($('.chat-content.open').length > 0) {
                    $('.left-sidebar').hide();

                    $('.center-sidebar').show();
                    $('.center-sidebar').addClass('side-active');

                    // $('#send-form').css('position', 'fixed');
                    // $('#send-form').css('width', '100%');
                    // $('#send-form').css('padding', '1rem');
                    // $('#send-form').css('left', '0');

                    $('.cockpit-buttons').removeClass('col-11').addClass('col-12');
                    //$('.cockpit-textarea-col').removeClass('col-11').addClass('col-12');
                    $('.cockpit-button-send-col').hide();
                    $('.send-button').show();

                    $('.cockpit-textarea-links').css('position', 'absolute');
                    $('.cockpit-textarea-links').css('top', '-50px');
                    $('.cockpit-textarea-links').css('z-index', '99');
                    $('.cockpit-textarea-links').css('right', '0');

                    $('.right-sidebar').hide();

                    $('.cockpit-call-phone').hide();
                    $('.cockpit-call-off').css('display','none');
                    $('.cockpit-wrapper .additional-btns').css('display','none');
                    $('.show_logs_modal').hide();

                    let name = $('input[name="chat_select"]:checked').val() == 'Customers' && response?.first_name && response?.last_name
                        ? response.first_name+' '+response.last_name : $(from_this).data('user_phone');
                    if (!name) {
                        name = $(from_this).data('user_email');
                        if (!name)
                            name = $(from_this).data('id')
                    }

                    if($('input[name="chat_select"]:checked').val() == 'Customers')
                        $('.mobile-links .mobile-link-additional').removeClass('d-none')
                    else
                        $('.mobile-links .mobile-link-additional').addClass('d-none')


                    console.log($(from_this).data('user_phone'), $(from_this).data('user_email'), $(from_this).data('id'));

                    $('.mobile-back-to-list-button .info').html(name);
                    $('.mobile-back-to-list-button .add-info-phone').text($('input[name="chat_select"]:checked').val() == 'Customers' && response?.first_name && response?.last_name ? $(from_this).data('user_phone') : '');
                    $('.mobile-back-to-list-button .add-info-email').text($(from_this).data('user_phone') ? $(from_this).data('user_email') : '');



                // }
/*

                else {
                    $('.left-sidebar').show();

                    $('.center-sidebar').hide();

                    $('#send-form').css('position', '');
                    $('#send-form').css('width', '');
                    $('#send-form').css('padding', '');
                    $('#send-form').css('left', '');

                    $('.cockpit-buttons').removeClass('col-12').addClass('col-11');
                    $('.cockpit-textarea-col').removeClass('col-12').addClass('col-11');
                    $('.cockpit-button-send-col').show();
                    $('.send-button').hide();

                    $('.cockpit-textarea-links').css('position', '');
                    $('.cockpit-textarea-links').css('top', '');
                    $('.cockpit-textarea-links').css('z-index', '');
                    $('.cockpit-textarea-links').css('right', '');

                    $('.right-sidebar').hide();

                    $('.cockpit-call-phone').hide();
                    $('.show_logs_modal').hide();
                    $('.container.cockpit-wrapper').css('padding', '');
                }

*/
            } else {
                $('#cockpit-leads-link').show();
                $('.left-sidebar').show();

                $('.center-sidebar').show();
                $('.center-sidebar').addClass('side-active');

                $('#send-form').css('position', '');
                $('#send-form').css('width', '');
                $('#send-form').css('padding', '');
                $('#send-form').css('left', '');

                $('.cockpit-buttons').removeClass('col-12').addClass('col-11');
                //$('.cockpit-textarea-col').removeClass('col-12').addClass('col-11');
                $('.cockpit-button-send-col').show();
                $('.send-button').hide();

                $('.cockpit-textarea-links').css('position', '');
                $('.cockpit-textarea-links').css('top', '');
                $('.cockpit-textarea-links').css('z-index', '');
                $('.cockpit-textarea-links').css('right', '');

                $('.right-sidebar').show();

                $('.cockpit-call-phone').show();
                $('.cockpit-call-off').css('display','flex');
                $('.cockpit-wrapper .additional-btns').css('display','');
                $('.show_logs_modal').show();
            }
        }, 1000);

    },
    syncAvailableSubmitButtons(contact, chatAvailable) {
        const flag = (selector) => $(selector).val() === '1';
        const hasEmailRecipient = Boolean($(contact).data('user_email'));
        const hasPhoneRecipient = Boolean($(contact).data('user_phone'));
        const emailAvailable = flag('#cockpitEmailAvailable') && hasEmailRecipient;
        const phoneAvailable = flag('#cockpitPhoneAvailable') && hasPhoneRecipient;
        const smsAvailable = flag('#cockpitSmsAvailable') && hasPhoneRecipient;

        $('#org_send_email')
            .toggleClass('d-none', !emailAvailable)
            .toggleClass('btn-light', !emailAvailable);
        $('#call').toggleClass('d-none', !phoneAvailable);
        $('#org_send_sms').toggleClass('d-none', !phoneAvailable).prop('disabled', !smsAvailable);

        if (!emailAvailable) {
            $('#org_send_email').removeClass('btn-primary sending');
        }
        if (!smsAvailable) {
            $('#org_send_sms').removeClass('btn-primary sending').addClass('btn-light');
        }
        if (!chatAvailable) {
            $('#org_send_chat').removeClass('btn-primary sending').addClass('btn-light');
        }

        const current = document.querySelector('.composer-modes .sending');
        const currentAvailable = current
            && current.getClientRects().length > 0
            && !current.disabled
            && current.getAttribute('aria-disabled') !== 'true';
        const next = [
            emailAvailable ? document.querySelector('#org_send_email') : null,
            smsAvailable ? document.querySelector('#org_send_sms') : null,
            chatAvailable ? document.querySelector('#org_send_chat') : null,
        ].find(Boolean);

        if (!currentAvailable && next) {
            $(next).trigger('click');
        }

        const hasSendChannel = Boolean(next);
        $('#send-form').toggleClass('is-channel-locked', !hasSendChannel);
        $('#message, .cockpit-subject-input-value').prop('disabled', !hasSendChannel);
        $('button.send').prop('disabled', !hasSendChannel);
        if (!hasSendChannel) {
            $('.composer-modes .sending').removeClass('sending btn-primary').addClass('btn-light');
            $('#sms-counter').html('<b>No channel available</b>');
        }
    },

    showAllSubmitButtons(preserveChannel = false) {
        $('#sendButton').prop('disabled', false);

        if (preserveChannel) {
            $('#org_send_sms, #org_send_email, #call').removeClass('d-none');
            if (document.querySelector('#nonVerificationMessage')) {
                $('#nonVerificationMessage').removeClass('d-none').addClass('d-lg-flex');
            }
            return;
        }

        $('#org_send_sms').removeClass(['d-none', 'btn-primary', 'sending']);
        $('#org_send_sms').addClass('btn-light');

        $('#org_send_email').removeClass(['d-none', 'btn-light']);
        $('#org_send_email').addClass(['btn-primary', 'sending']);

        $('#call').removeClass('d-none');

        if (document.querySelector('#nonVerificationMessage')) {
            $('#nonVerificationMessage').removeClass('d-none').addClass('d-lg-flex');
        }

        $('#sms-counter').html('<b>Email</b>');
        // $('#sms-counter').html('<b>SMS</b> <span class="remaining">160</span> / <span class="messages">0</span>');

        $('#org_send_email .svg_1').css('display', 'inline-block');
        $('#org_send_email .svg_2').css('display', 'none');

        $('#org_send_sms .svg_1').css('display', 'none');
        $('#org_send_sms .svg_2').css('display', 'inline-block');

        $('.messages_settings').removeClass('d-none');

        $('#org_send_email').trigger('click');
    },

    showOnlyPhoneSubmitButtons(preserveChannel = false) {
        if (preserveChannel) {
            $('#call, #org_send_sms').removeClass('d-none');
            $('#org_send_email').addClass('d-none').removeClass(['btn-primary', 'sending']);
            if (document.querySelector('#nonVerificationMessage')) {
                $('#nonVerificationMessage').removeClass('d-none').addClass('d-lg-flex');
            }
            const smsLocked = $("#twilioPhoneVerification").val() !== "1";
            $('#org_send_sms').prop('disabled', smsLocked);
            $('button.send').prop('disabled', smsLocked);
            return;
        }

        if ($("#twilioPhoneVerification").val() === "1") {
            $('button.send').prop('disabled', false);
        } else {
            $('button.send').prop('disabled', true);
        }

        $('#call').removeClass('d-none');

        $('#org_send_sms').removeClass(['d-none', 'btn-light']);
        $('#org_send_sms').addClass(['btn-primary', 'sending']);

        $('#org_send_email').addClass('d-none');
        $('#org_send_email').removeClass(['btn-primary', 'sending']);

        if (document.querySelector('#nonVerificationMessage')) {
            $('#nonVerificationMessage').removeClass('d-none').addClass('d-lg-flex');
        }

        $('#sms-counter').html('<b>Email</b>');
        // $('#sms-counter').html('<b>SMS</b> <span class="remaining">160</span> / <span class="messages">0</span>');

        $('#org_send_sms .svg_1').css('display', 'inline-block');
        $('#org_send_sms .svg_2').css('display', 'none');
        $('#org_send_email .svg_1').css('display', 'none');
        $('#org_send_email .svg_2').css('display', 'inline-block');

        $('.messages_settings').addClass('d-none');

        $('#org_send_sms').attr('disabled', false);
        $('#org_send_sms').trigger('click');
        if ($("#twilioPhoneVerification").val() !== "1") {
            $('#org_send_sms').attr('disabled', true);
        }

    },
    showOnlyEmailSubmitButtons(preserveChannel = false) {
        if (preserveChannel) {
            $('#org_send_email').removeClass('d-none');
            $('#org_send_sms').addClass('d-none').removeClass(['btn-primary', 'sending']);
            $('#call').addClass('d-none');
            if (document.querySelector('#nonVerificationMessage')) {
                $('#nonVerificationMessage').addClass('d-none').removeClass('d-lg-flex');
            }
            return;
        }

        $('#org_send_email').addClass(['btn-primary', 'sending']);
        $('#org_send_email').removeClass(['d-none', 'btn-light']);
        $('#org_send_sms').addClass('d-none');
        $('#org_send_sms').removeClass(['btn-primary', 'sending']);
        $('#call').addClass('d-none');

        if (document.querySelector('#nonVerificationMessage')) {
            $('#nonVerificationMessage').addClass('d-none').removeClass('d-lg-flex');
        }

        $('#sms-counter').html('<b>Email</b>');
        $('#org_send_sms .svg_1').css('display', 'none');
        $('#org_send_sms .svg_2').css('display', 'inline-block');
        $('#org_send_email .svg_1').css('display', 'inline-block');
        $('#org_send_email .svg_2').css('display', 'none');

        $('.messages_settings').removeClass('d-none');
        $('#org_send_email').trigger('click');
    },
    replaceCountNewMessages(user) {
        // $.ajax({
        //     type: 'POST',
        //     url: '/cockpit/get-count-new-messages',
        //     success: function (response) {
        //         $('#new_customers').text(response.users);
        //         $('#new_not_customers').text(response.not_customers);
        //         $('#new_incidents').text(response.incidents);
        //         $('#new_customers_with_incidents').text(response.messages_users_with_incidents);
        //         $('.chat-count-new').each(function(i,el) {
        //             if ($(el).text() == 0) {
        //                 $(el).hide();
        //             }else{
        //                 $(el).show();
        //             }
        //         })
        //     }
        // });
    },
    replaceUserInfo(user) {
        let tmpl = $('#user_info_tmpl').html();
        let view = user;
        let html = Mustache.render(tmpl, view);
        $('.sidebar_user_info').html(html);
    },
    replaceOrders(orders, isCustomer) {
        $('#orders #orders-cont').html('');
        if(!isCustomer){
            $('#orders').addClass('d-none');
            return
        }else{
            $('#orders').removeClass('d-none');
        }

        if (orders && orders.length > 0) {
            $('.deploy-btn[data-target="#orders-cont"]').removeClass('d-none')
            $('#orders #orders-count').text(`(${orders.length})`)
            for(let order of orders){
                let template = $('#right-order-tmpl').clone(true)
                template.attr('id','')
                template.removeClass('d-none')
                template.addClass('open-new-modal')
                template.attr('data-customer_id', order.customer_org_local_id)
                template.attr('data-step', 'appointments')
                template.attr('data-internal_step', 'appointment')
                template.attr('data-parent', order.id)
                template.attr('data-parent-local-id', order.org_local_id)
                template.find('.order-type').text(order.products[0].title)
                template.find('.order-date').text(order.created_at_date)
                template.find('.order-status').text(order.pay_status)
                template.find('.order-total').text('$'+Number(order.total).toFixed(2))
                if (order.products[0].requires_payment === 0) {
                    template[0].children[1].style.opacity = '0';
                }
                $('#orders #orders-cont').append(template)
            }
        }else{
            $('.deploy-btn[data-target="#orders-cont"]').addClass('d-none')
            $('#orders #orders-count').text('')
        }
    },
    replaceJobs(jobs, isCustomer, customerOrgLocalId = null) {
        $('#jobs #jobs-cont').html('');
        if(!isCustomer){
            $('#jobs').addClass('d-none');
            return
        }else{
            $('#jobs').removeClass('d-none');
        }

        if(jobs && jobs.length > 0){
            $('.deploy-btn[data-target="#jobs-cont"]').removeClass('d-none')
            $('#jobs #jobs-count').html(`(${jobs.length})`)
            for(let job of jobs){
                let template = $('#right-job-tmpl').clone(true)
                template.attr('id','')
                template.removeClass('d-none')
                template.attr('href', '#')
                template.find('.job-type-name').text(job.entity=='jobs' ? 'Job: ' : 'Job Request: ')
                template.find('.job-type').text(job.service_name)
                template.find('.job-date').text(job.created_at_date)
                template.find('.job-status').text(job.status)
                template.find('.job-total').text('$'+Number(job.total).toFixed(2))
                template.attr('data-customer_id', job.customer_org_local_id ?? customerOrgLocalId);
                template.attr('data-step', 'projects')
                template.attr('data-internal_step', job.entity=='jobs' ? 'job' : 'job-request')
                template.attr('data-parent', job.entity=='jobs' ? job.job_request_id : job.id)
                template.attr('data-parent-local-id', job.entity=='jobs' ? job.job_request_org_local_id : job.org_local_id)
                template.attr('data-id', job.id)
                template.attr('data-entity-local-id', job.org_local_id)
                template.attr('data-entity_id', job.id)
                template.attr('data-entity', job.entity=='jobs' ? 'job' : 'request');
                $('#jobs #jobs-cont').append(template)
            }
        }else{
            $('.deploy-btn[data-target="#jobs-cont"]').addClass('d-none')
            $('#jobs #jobs-count').text('')
        }
    },
    replaceVendorFiles(vendor_files, hide, vendor_id){
        if (hide) {
            $('#vendors_attachments').addClass('d-none');
            return;
        }else{
            $('#vendors_attachments').removeClass('d-none');
        }
        let files = '<div class="d-flex justify-content-between align-items-start pt-3 px-3">'+
                    '<div class="flex-1 cockpit-title">Files & Pictures</div>'+
                    `<div class="mt-1 text-right flex-1 text-nowrap text-primary mb-2 cursor-pointer add-vendor-attachemnt upload-files" data-id="${vendor_id}" data-file_type="doc" data-entity="vendor">+ Pics &amp; Docs</div>`+
                    '</div>';
        if (vendor_files && vendor_files.length > 0) {
            files += '<div class="files-container d-flex flex-wrap px-3">';
            vendor_files.forEach(element => {
                let path = '/images/document-image.png';
                if (element.type == 'img') {
                    path = `/files/${element.path}`;
                }
                files += '<div class="file d-flex flex-column justify-content-between">'+
                            '<div class="mb-2">'+
                                `<img class="vendor-image" src="${path}">`+
                            '</div>'+
                            '<div class="d-flex justify-content-between mb-1">'+
                                `<div class="file-name"><a class="text-primary preview-file-btn" href="#" data-src="${path}">${element.name}</a></div>`+
                                `<div class="file-menu cursor-pointer d-flex align-items-center" data-id="${vendor_id}" data-file_id="${element.id}" data-d_link="${element.d_link}">`+
                                    '<div class="dots"></div>'+
                                '</div>'+
                            '</div>'+
                            '<div class="file-description">'+
                                `<div class="size">${element.size}</div>`+
                                `<div class="upload-time">${element.time}</div>`+
                            '</div>'+
                        '</div>'
            });

        }
        files += '</div></div>'
        $('#vendors_attachments').html(files);
        if (vendor_id) {
            const vendor = new Vendor(vendor_id);
            vendor.scopeOpenDropZoneListener();
            vendor.setAttachmentCallbackDelete(()=>{
                let elem = $('.chat-content.open').parent();
                elem.click();
                $('.file-menu-modal').hide();
            });
            vendor.setAttachmentCallbackPreview();
        }
    },
    replaceSubscriptions(subscriptions, customerOrgLocalId = null){
        if(subscriptions && subscriptions.length > 0){
            $('#subscriptions').removeClass('d-none');
            $('#subscriptions #subscriptions-cont').html('');
            for(let sub of subscriptions){
                let template = $('#right-sub-tmpl').clone(true)
                template.attr('id','')
                template.removeClass('d-none')
                template.addClass('open-new-modal');
                template.attr('data-customer_id', sub.customer_org_local_id ?? customerOrgLocalId)
                template.attr('data-step', 'subscriptions')
                template.attr('data-internal_step', 'appointment-subscription')
                template.attr('data-parent', sub.org_local_id)
                template.find('.subs-title').text(sub?.service?.title)
                template.find('.subs-date').text(sub.created_at_date)
                $('#subscriptions #subscriptions-cont').append(template)
            }
        }else{
            $('#subscriptions').addClass('d-none');
        }
    },
    replaceFollowUps(hide = false) {
        if (hide) {
            $('#follow-ups').hide();
        }else{
            $('#follow-ups').show();
            let customer_id = $('#send-form input[name="customer_id"]').val();
            let contact = '';
            let data = {};
            if (customer_id === "") {
                let email = $('#send-form input[name="email"]').val();
                if (email !== "") {
                    contact = email;
                }else{
                    contact = $('#send-form input[name="phone"]').val();
                }
                data = {contact: contact};
            }else{
                data = {user_id: customer_id};
            }

            $.ajax({
                type: 'GET',
                url: '/cockpit/get-follow-ups',
                data: data,
                success: function (response) {
                    $('#follow-ups .row').removeClass('d-none');
                    $('#follow-ups-outer').html(response);
                },
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        }
    },
    replaceIncidents(incidents, hide=false) {
        if (incidents) {
            $('#incidents').removeClass('d-none');
            $('#incidents #incidents-cont').html('');
            $('#incidents #add-incident').removeClass('d-none').addClass('d-flex');
            $('#incidents #other-incident').addClass('d-none');
            for(let incident of incidents){
                let template = $('#right-incident-tmpl').clone(true)
                console.log(incident)
                template.attr('id','')
                template.removeClass('d-none')
                template.find('.incident-title').text(incident.title)
                template.find('.incident-date').text(incident.created_at)
                template.find('.incident-details').text(incident.details)
                template.find('.incident-creator').text(`Created by ${incident.creator}`)
                template.attr('data-incident_id', incident.id)
                $('#incidents #incidents-cont').append(template)
            }
        } else if (window.location.pathname.match('/phone-') || window.location.pathname.match('/email-')) {
            $('#incidents').removeClass('d-none');
            $('#incidents #incidents-cont').html('');
            $('#incidents #add-incident').removeClass('d-flex').addClass('d-none');
            $('#incidents #other-incident').removeClass('d-none');
        }else if(hide){
            $('#incidents').addClass('d-none');
        }
    },
    userFullSearch() {
        let $this = this;
        $('body').on('input','#user_full_search', function(e) {
            if($('#user_full_search').val().length)
                $('.reset-search').removeClass('d-none')
            else
                $('.reset-search').addClass('d-none')

            if ($('#user_full_search').val().length > 3 || $('#user_full_search').val().length == 0) {
                setTimeout($this.getUsers, 2000);
            }
        });
        $('body').on('click','.reset-search', function(e) {
            $('#user_full_search').val('')
            $('.reset-search').addClass('d-none')
            $this.getUsers()
        });
    },
    forwardingList() {
        $.ajax({
            type: 'POST',
            url: '/cockpit/forwarding-list',
            success: function (response) {
                $('.forwarding').html(response);
            }
        }).fail(function (jqXHR, exception) {
            if (jqXHR.status == 403) {
                localStorage.setItem('cockpit_reload_flag', true);
                window.location.reload();
            }
        });
    },
    insertBackButton(block) {
        if (block.find('.back-to-sidebar').length) {
            return;
        }
        const backButton = $('<a/>', {
            class: 'text-danger text-underline back-to-sidebar',
            text: '< Back',
            css: {
                'font-size': '14px',
                'margin-left': '0px',
                'margin-right': '20px',
                'cursor': 'pointer',
            }
        });
        block.prepend(backButton);
    },
    getUserInfoModal() {
        const sidebar = $('.right-sidebar');
        const $this = this;

        $('body').on('click', '#contact-options-modal .chat-title, #incidents .chat-title, #contact-options-modal .vendor-info', function (e) {
            e.preventDefault();

            let id = $('.user_data').data('id');
            let id2 = $(this).parent().find('.queue_user_id').text();
            let user_id = id || id2;
            let isVendor = $('#send-form input[name="type"]').val() == 'vendor';

            // --- Если есть user_id — открываем info ---
            if (user_id) {
                let url = isVendor ? '/cockpit/vendor_info/' + user_id : '/cockpit/user_info/' + user_id;

                $.ajax({
                    type: 'GET',
                    url: url,
                    success: function (response) {
                        const $response = $(response);
                        const modalId = $response.attr('id');

                        // --- user_info_modal остаётся обычной модалкой ---
                        if (modalId === 'user_info_modal') {
                            if ($('#user_info_modal').length)
                                $('#user_info_modal').replaceWith(response);
                            else
                                $('.container-fluid').append(response);

                            $('.open_chat').addClass('d-none');
                            if (id) $('#contact-options-modal').modal('hide');
                            $('#user_info_modal').modal('show');
                            return;
                        }

                        // --- Для мобильных устройств показываем модальное окно, для десктопа вставляем в .right-sidebar ---
                        $('#contact-options-modal').modal('hide');

                        const $modalContent = $response.find('.modal-content');
                        if ($modalContent.length) {
                            // Проверяем ширину экрана
                            if (window.innerWidth < 1024) {
                                // Для мобильных устройств показываем как модальное окно
                                const modalWrapper = $('<div/>', {
                                    class: 'modal fade',
                                    id: modalId || ('modal-' + Date.now()),
                                    tabindex: '-1',
                                    role: 'dialog'
                                }).append($modalContent);

                                $('body').append(modalWrapper);
                                modalWrapper.modal('show');

                                // Удаляем модальное окно после закрытия
                                modalWrapper.on('hidden.bs.modal', function () {
                                    $(this).remove();
                                });
                            } else {
                                $('.cockpit-wrapper').hide()
                                sidebar.data('previous-content', sidebar.html());

                                const clonedContent = $modalContent.clone(true, true);
                                const header = clonedContent.find('.modal-header').first();

                                if (header.length) {
                                    $this.insertBackButton(header);
                                }

                                const wrapper = $('<div/>', {
                                    class: 'standard-modal',
                                    id: modalId || ('modal-' + Date.now())
                                }).append(clonedContent);

                                sidebar.empty().append(wrapper);

                                sidebar.off('click', '.back-to-sidebar').on('click', '.back-to-sidebar', function () {
                                    $this.restoreRightSidebar();
                                });
                            }
                        }
                    },
                    error: function (jqXHR) {
                        if (jqXHR.status == 403) {
                            localStorage.setItem('cockpit_reload_flag', true);
                            window.location.reload();
                        }
                    }
                });

            } else {
                // Проверяем ширину экрана
                if (window.innerWidth < 1024) {
                    // Для мобильных устройств показываем как модальное окно
                    $('#contact-options-modal').modal('hide');

                    const isVendorInfo = $(this).hasClass('vendor-info');
                    const modalSelector = isVendorInfo ? '#vendor-create-modal' : '#contact-create-modal';
                    $(modalSelector).modal('show');
                } else {
                    $('.cockpit-wrapper').hide()
                    $('#contact-options-modal').modal('hide');

                    const isVendorInfo = $(this).hasClass('vendor-info');
                    const formSelector = isVendorInfo ? '#create-vendor-form' : '#create-contact-form';
                    const modalSelector = isVendorInfo ? '#vendor-create-modal' : '#contact-create-modal';

                    const $modal = $(modalSelector);
                    const $modalContent = $modal.find('.modal-content');

                    if ($modalContent.length) {
                        sidebar.data('previous-content', sidebar.html());

                        const clonedContent = $modalContent.clone(true, true);

                        const header = clonedContent.find('.modal-header').first();
                        if (header.length) {
                            $this.insertBackButton(header);
                        }

                        const wrapper = $('<div/>', {
                            class: 'standard-modal',
                            id: modalSelector.replace('#', '')
                        }).append(clonedContent);

                        sidebar.empty().append(wrapper);

                        sidebar.off('click', '.back-to-sidebar').on('click', '.back-to-sidebar', function () {
                            $this.restoreRightSidebar();
                        });
                    }
                }
            }
            $("#phone").mask("000-000-0000");
            $this.validationForm();
        });
    },
    // ----------------- helpers -----------------
    getFormContainer($form) {
        // если форма внутри standard-modal в сайдбаре — вернём этот wrapper
        let $wrapper = $form.closest('.standard-modal');
        if ($wrapper.length) return $wrapper;
        // если форма внутри обычной модалки
        let $modal = $form.closest('.modal');
        if ($modal.length) return $modal;
        // не найдено — вернём сам form как контейнер
        return $form;
    },

    closeFormContainer($form) {
        const sidebar = $('.right-sidebar');
        const $container = this.getFormContainer($form);

        if ($container.hasClass('standard-modal')) {
            const previous = sidebar.data('previous-content');
            if (previous !== undefined) sidebar.html(previous);
            else sidebar.empty();
        } else if ($container.hasClass('modal')) {
            $container.modal('hide');
        } else {
            // fallback — просто удаляем контейнер формы
            $container.remove();
        }
    },

// ----------------- validationForm -----------------
    validationForm(formId, validationFields, isSelectErrorFields = false) {
        // Попробуем найти форму в сайдбаре (вставленная) сначала, затем по всему документу
        let $form = $('.right-sidebar').find(`#${formId}`).first();
        if (!$form.length) $form = $(`#${formId}`).first();
        if (!$form.length) return false; // формы нет — валидировать нечего

        const formData = new FormData($form[0]);
        const validator = new Validator({
            'email': ['required'],
            'phone': ['required', { regexp: /[0-9]{3}-[0-9]{3}-[0-9]{4}/ }],
            'first_name': ['required'],
            'last_name': ['required'],
            'vendor_name': ['required'],
        });

        let validate_flag = true;

        validationFields.forEach(element => {
            const value = formData.get(element);
            if (validator.validate(element, value)) {
                if (isSelectErrorFields)
                    $form.find('[name="' + element + '"]').removeClass('border-danger').css('border', '');
            } else {
                validate_flag = false;
                if (isSelectErrorFields)
                    $form.find('[name="' + element + '"]').addClass('border-danger').css('border', '2px solid');
            }
        });

        return validate_flag;
    },
    saveContactToCustomer() {
        const $this = this;
        const sidebar = $('.right-sidebar');

        // --- Делегированные обработчики input для динамического контента ---
        const attachInputValidation = (formSelector, fields) => {
            $(document).off('input', `${formSelector} input`);
            $(document).on('input', `${formSelector} input`, function () {
                const formId = $(this).closest('form').attr('id');
                if ($this.validationForm(formId, fields))
                    $(`#${formId} button[type="submit"]`).attr('disabled', false);
                else
                    $(`#${formId} button[type="submit"]`).attr('disabled', true);
            });
        };

        attachInputValidation('#create-contact-form', validation_fields);
        attachInputValidation('#create-vendor-form', vendor_validation_fields);

        // --- submit для контакта ---
        $(document).off('click', '#create-contact-form button[type=submit]');
        $(document).on('click', '#create-contact-form button[type=submit]', function (e) {
            e.preventDefault();
            const $form = $(this).closest('form#create-contact-form');
            if (!$this.validationForm($form.attr('id'), validation_fields, true)) return;

            $.ajax({
                type: 'POST',
                url: '/cockpit/org-save-contact-to-customer',
                data: new FormData($form[0]),
                processData: false,
                contentType: false,
                success: function (response) {
                    // обновляем данные внутри формы, если есть
                    const $customerEl = $form.find('#customer');
                    if ($customerEl.length) {
                        $customerEl.data('id', response.customer_id);
                        $customerEl.data('user_email', $form.find('input[name="email"]').val());
                        $customerEl.data('user_phone', $form.find('input[name="phone"]').val());
                    }

                    $('input[name=customer_id]').val(response.customer_id);
                    history.pushState(null, null, '/cockpit/' + response.public_id);
                    $this.restoreRightSidebar();
                    $this.getCurrentUser($customerEl[0]);

                    const newUserLink = $(`
                        <a class="text-decoration-none align-items-center chat d-flex justify-content-between border-bottom"
                           id="${response.customer_id}"
                           data-id="${response.customer_id}"
                           href="/cockpit/${response.public_id}"
                           data-public_id="${response.public_id}"
                           data-user_phone="${$form.find('input[name="phone"]').val()}"
                           data-user_email="${$form.find('input[name="email"]').val()}"
                           data-current-phone=""
                           data-current-email=""
                           style="min-height:2.5rem; padding:12px 1rem">
                            <div class="chat-content d-flex flex-column w-100" style="min-width:0;">
                                <div class="d-flex justify-content-between align-items-start" style="font-size:16px;">
                                    <div class="flex-1 user-name-block">${$form.find('input[name="first_name"]').val()} ${$form.find('input[name="last_name"]').val()}</div>
                                    <div class="ml-1 badge-custom-cont d-flex justify-content-end align-items-center"></div>
                                </div>
                            </div>
                        </a>
                    `);

                    $('#users_loop').prepend(newUserLink);
                    $('[data-id="' + response.customer_id + '"]').trigger('click');
                },
                error: function (response) {
                    if (response.responseJSON && response.responseJSON.errors)
                        errors.showAlerts(response.responseJSON.errors);
                }
            }).fail(function (jqXHR) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        });

        // --- submit для вендора ---
        $(document).off('click', '#create-vendor-form button[type=submit]');
        $(document).on('click', '#create-vendor-form button[type=submit]', function (e) {
            e.preventDefault();
            const $form = $(this).closest('form#create-vendor-form');
            if (!$this.validationForm($form.attr('id'), vendor_validation_fields, true)) return;

            $.ajax({
                type: 'POST',
                url: '/cockpit/org-save-contact-to-vendor',
                data: new FormData($form[0]),
                processData: false,
                contentType: false,
                success: function (response) {
                    const newVendorLink = $(`
                        <a class="text-decoration-none align-items-center chat d-flex justify-content-between border-bottom"
                           id="${response.vendor_id}"
                           data-type="vendor"
                           data-id="${response.vendor_id}"
                           href="/cockpit/${response.vendor_id}/vendor"
                           data-user_phone="${$form.find('input[name="phone"]').val()}"
                           data-user_email="${$form.find('input[name="email"]').val()}"
                           data-current-phone=""
                           data-current-email=""
                           style="min-height:2.5rem; padding:12px 1rem">
                            <div class="chat-content d-flex flex-column w-100" style="min-width:0;">
                                <div class="d-flex justify-content-between align-items-start" style="font-size:16px;">
                                    <div class="flex-1 user-name-block">${$('#vendor_name').val()}</div>
                                    <div class="ml-1 badge-custom-cont d-flex justify-content-end align-items-center"></div>
                                </div>
                            </div>
                        </a>
                    `);

                    $('#vendors_loop').prepend(newVendorLink);
                    newVendorLink.trigger('click');

                    const previous = sidebar.data('previous-content');
                    if (previous !== undefined) sidebar.html(previous);
                },
                error: function (response) {
                    if (response.responseJSON && response.responseJSON.errors)
                        errors.showAlerts(response.responseJSON.errors);
                }
            }).fail(function (jqXHR) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        });
    },
    getUserInfoEditModal() {
        const $this = this;
        const sidebar = $('.right-sidebar');

        const loadEditForm = (url, modalId, formId, validationFields) => {
            $.ajax({
                type: 'GET',
                url: url,
                success: function (response) {
                    const $response = $(response);
                    let $modal = $response.filter('.modal').first();
                    if (!$modal.length) {
                        $modal = $response.find('.modal').first();
                    }
                    if (!$modal.length) {
                        return;
                    }
                    if (modalId) {
                        $modal.attr('id', modalId);
                    }

                    $('.modal-backdrop').remove();
                    $modal.removeClass('fade');
                    // only the FETCHED modal loses its close X (it renders inline in the pane
                    // on desktop) — the bare global selector was stripping the close button
                    // from every other modal on the page
                    $modal.find('.standart-close-btn').remove();

                    const $modalContent = $modal.find('.modal-content');
                    if (!$modalContent.length) {
                        return;
                    }

                    if (window.innerWidth < 1024) {
                        $('body').append($modal);
                        $modal.addClass('fade').modal('show');
                        $modal.on('hidden.bs.modal', function () {
                            $(this).remove();
                        });
                    } else {
                        $('.cockpit-wrapper').hide();
                        sidebar.data('previous-content', sidebar.html());

                        const clonedContent = $modalContent.clone(true, true);
                        const header = clonedContent.find('.modal-header').first();
                        if (header.length) {
                            $this.insertBackButton(header);
                        }

                        const wrapper = $('<div/>', {
                            class: 'standard-modal',
                            id: modalId
                        }).append(clonedContent);

                        sidebar.empty().append(wrapper);

                        sidebar.off('click', '.back-to-sidebar').on('click', '.back-to-sidebar', function () {
                            $this.restoreRightSidebar();
                        });

                        $modal.remove();
                    }

                    if (typeof masks !== 'undefined') masks.init();

                    const validateCb = () => {
                        if ($this.validationForm(formId, validationFields))
                            $(`#${formId} button[type="submit"]`).attr('disabled', false);
                        else
                            $(`#${formId} button[type="submit"]`).attr('disabled', true);
                    };
                    validateCb();

                    for (let field of validationFields) {
                        $(document).off('input', `#${formId} input[name=${field}]`);
                        $(document).on('input', `#${formId} input[name=${field}]`, validateCb);
                    }
                },
                error: function (jqXHR) {
                    if (jqXHR.status == 403) {
                        localStorage.setItem('cockpit_reload_flag', true);
                        window.location.reload();
                    }
                }
            });
        };

        // редактирование пользователя
        $('body').on('click', '#user_info_modal .user_info_edit', function (e) {
            e.preventDefault();
            $('#user_info_modal').modal('hide');
            const id = $('.user_data').data('id');
            loadEditForm('/cockpit/user_info_edit/' + id, 'user_info_edit_modal', 'user-info-form', validation_fields);
        });

        // редактирование вендора
        $('body').on('click', '#user_info_modal .vendor_info_edit', function (e) {
            e.preventDefault();
            $('#user_info_modal').modal('hide');
            const id = $('.user_data').data('id');
            const vendorFields = ['email', 'phone', 'vendor_name', 'address', 'zip_code'];
            loadEditForm('/cockpit/vendor_info_edit/' + id, 'vendor_info_edit_modal', 'vendor-info-form', vendorFields);
        });
    },
    updateUser() {
        const $this = this;
        const sidebar = $('.right-sidebar');

        const attachInputValidation = (formSelector, fields) => {
            $(document).off('input', `${formSelector} input`);
            $(document).on('input', `${formSelector} input`, function () {
                const formId = $(this).closest('form').attr('id');
                if ($this.validationForm(formId, fields))
                    $(`#${formId} button[type="submit"]`).attr('disabled', false);
                else
                    $(`#${formId} button[type="submit"]`).attr('disabled', true);
            });
        };

        attachInputValidation('#user-info-form', validation_fields);
        attachInputValidation('#vendor-info-form', ['email','phone','vendor_name','address','zip_code']);

        // --- submit для редактирования пользователя ---
        $(document).off('click', '#user-info-form button[type=submit]');
        $(document).on('click', '#user-info-form button[type=submit]', function (e) {
            e.preventDefault();
            const $form = $(this).closest('form#user-info-form');
            if (!$this.validationForm($form.attr('id'), validation_fields, true)) return;

            $.ajax({
                type: 'POST',
                url: '/cockpit/user_info_update',
                data: new FormData($form[0]),
                processData: false,
                contentType: false,
                success: function (response) {
                    if (response.success) {
                        $('.component-data-save .text-success')
                            .removeClass('d-none')
                            .text(response.message);

                        if (response.updatedInfo) {
                            for (let key in response.updatedInfo) {
                                $(`[data-e-field="${key}"]`).text(response.updatedInfo[key]);
                            }
                        }

                        $($('[data-id=' + $(`[data-e-field="user_id"]`).text() + '] > div > div > div')[0]).text(
                            response.updatedInfo.first_name + " " + response.updatedInfo.last_name
                        );
                        setTimeout(() => {
                            $($('[data-id=' + $(`[data-e-field="user_id"]`).text() + ']')).trigger('click');
                            $('.component-data-save .text-success')
                                .addClass('d-none')
                                .text('');
                            $this.restoreRightSidebar();
                            $('#select-customers').trigger('click');
                        }, 1000)
                    }
                },
                error: function (response) {
                    if (response.responseJSON && response.responseJSON.errors)
                        errors.showAlerts(response.responseJSON.errors);
                }
            });
        });

        // --- submit для редактирования вендора ---
        $(document).off('click', '#vendor-info-form button[type=submit]');
        $(document).on('click', '#vendor-info-form button[type=submit]', function (e) {
            e.preventDefault();
            const $form = $(this).closest('form#vendor-info-form');
            if (!$this.validationForm($form.attr('id'), ['email','phone','vendor_name','address','zip_code'], true)) return;

            $.ajax({
                type: 'POST',
                url: '/cockpit/vendor_info_update',
                data: new FormData($form[0]),
                processData: false,
                contentType: false,
                success: function (response) {
                    if (response.success) {
                        if (response.updatedInfo) {
                            for (let key in response.updatedInfo) {
                                $(`[data-e-field="${key}"]`).text(response.updatedInfo[key]);
                            }
                        }

                        // восстанавливаем контент сайдбара и скрываем форму
                        const previous = sidebar.data('previous-content');
                        if (previous !== undefined) sidebar.html(previous);

                        // обновляем список вендоров
                        $('#select-vendors').trigger('click');
                    }
                },
                error: function (response) {
                    if (response.responseJSON && response.responseJSON.errors)
                        errors.showAlerts(response.responseJSON.errors);
                }
            });
        });
    },
    syncSpamContactButton(isSpam) {
        const normalizedSpam = [true, 1, '1'].includes(isSpam) ? 1 : 0;
        const button = $('#mark-spam-contact');

        button
            .data('is_spam', normalizedSpam)
            .toggleClass('btn-primary', normalizedSpam === 1)
            .toggleClass('btn-outline-primary', normalizedSpam === 0)
            .text(normalizedSpam === 1 ? 'Unmark as Spam' : 'Mark as Spam');

        return normalizedSpam;
    },
    getContactOptionsModal() {
        let $this = this;
        $('body').on('click', '.open-contact-options', function(e) {

            e.preventDefault();
            e.stopPropagation();
            $('.form-validation-errors').removeClass(['alert', 'alert-danger', 'alert-success']).html('');

            let id    = $('.user_data').data('id');
            let phone = $('.user_data').data('user_phone');
            let email = $('.user_data').data('user_email');
            let type = $('#chat-input-form input[name="type"]').val() //Позже стоит добавить type в user_data

            if (id) {
                $('#contact-options-modal #user_id').val(id);
                $('#contact-options-modal #user_id').show();
                $('#contact-options-modal .mark_as_lead').hide();
                $('#contact-options-modal .vendor-info').hide();
            }else{
                $('#contact-options-modal #user_id').hide();
                $('#contact-options-modal .mark_as_lead').show();
                $('#contact-options-modal .vendor-info').show();
            }
            $.ajax({
                type: 'GET',
                url: '/org-block-contact/check',
                data: ({
                    id: id,
                    phone: phone,
                    email: email,
                    type
                }),
                success: function (response) {
                    $('#block-contact').data('blocked', response.blocked);
                    $('#block-contact').addClass(response.blocked === 1 ? 'btn-primary' : 'btn-outline-primary');
                    $('#block-contact').removeClass(response.blocked === 1 ? 'btn-outline-primary' : 'btn-primary');
                    $('#block-contact').text(response.blocked === 1 ? 'Unblock Contact' : 'Block Contact');

                    $this.syncSpamContactButton(response.is_spam);
                    $('#contact-options-modal').modal('show');

                    if(response.lead == 1) {
                        $('.mark_as_lead').data('lead', 1);
                        $('.mark_as_lead').removeClass('btn-outline-primary').addClass('btn-primary');
                    } else {
                        $('.mark_as_lead').data('lead', 0);
                        $('.mark_as_lead').removeClass('btn-primary').addClass('btn-outline-primary');
                    }
                },
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        });
    },
    getForwardModal() {
        $('body').on('click', '.forward-email', function(e) {
            e.preventDefault();
            let id = $(this).data('forward');
            $('#forward-' + id).toggleClass(['d-none', 'd-flex']);
            $('.response-messages').removeClass(['alert-success', 'alert-danger']).addClass(['d-none']);
            $('#forward_id').val($(this).data('forward'));
            $('#forvard_modal').modal('show');
        });
    },
    getMetaInfo() {
        $('body').on('click', '.meta-info-msg-btn', function(e) {
            $.ajax({
                method: 'POST',
                url: '/cockpit/get-meta-info',
                data: {id: $(e.target).data('id')},
                success: (response)=>{
                    $('#form-container').html(response);
                    $('#meta-info-modal').modal('show');
                },
                error: (response)=> {

                }
            });
        });
    },
    forwardEmail() {
        $('body').on('click', '#forward_email_button', function(e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/cockpit/org_forward_system_email',
                data: ({
                    id: $('#forward_id').val(),
                    email: $('#forward_input').val(),
                }),
                success: function (response) {
                    $('#forward_input').val('');
                    $('#forvard_modal').modal('hide');
                    $('#success-action-modal .message').html(response.message || 'Email has been sent.');
                    $('#success-action-modal').modal('show');
                    setTimeout(function() {
                        $('#success-action-modal').modal('hide');
                    }, 3000);
                },
                error: function (jqXHR) {
                    const data = jqXHR.responseJSON;
                    let message = 'Failed to send email. Please try again.';
                    if (data) {
                        if (data.error || data.message) {
                            message = data.error || data.message;
                        } else if (data.errors && typeof data.errors === 'object') {
                            const parts = [];
                            Object.keys(data.errors).forEach(function (key) {
                                const msgs = data.errors[key];
                                if (Array.isArray(msgs)) parts.push(msgs.join(' ')); else parts.push(msgs);
                            });
                            if (parts.length) message = parts.join(' ');
                        }
                    } else if (jqXHR.responseText) {
                        message = jqXHR.responseText;
                    }
                    const errorHtml = '<img class="bb-standard-gif-image" src="/images/CH_Error.gif" alt="" style="height: 50px; margin-right: 13px; margin-left: -12px;"><p style="display: flex; flex-direction: column; justify-content: center; margin-bottom: 0;"> ' + message + '</p>';
                    $('#forvard_modal .response-messages').css('display', 'flex').html(errorHtml).removeClass(['d-none']).addClass(['alert-danger']);
                },
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        });
    },
    getTemplatesModal() {
        let $this = this;
        $('body').on('click', '#chat-messages #template_message', function(e) {
            if ( ! $('#chat-messages #templates-outer #template-messages-modal').html() ) {
                $this.getTemplates();
            }else{
                $('#template-messages-modal').modal('show');
            }
        });
    },
    getTemplates() {
        $.ajax({
            type: 'GET',
            url: '/cockpit/org-show-templates',
            success: function (response) {
                $('#chat-messages #templates-outer').html(response);
                $('#template-messages-modal').modal('show');
            },
        }).fail(function (jqXHR, exception) {
            if (jqXHR.status == 403) {
                localStorage.setItem('cockpit_reload_flag', true);
                window.location.reload();
            }
        });
    },
    getCreateTemplateModal() {
        $('body').on('click', '#chat-messages #show-create-template', function(e) {
            $('#template-name').val('');
            $('#template-text').val('');
            errors.hideAlerts();
            $('#create-template-message-modal').modal('show');
        });
    },
    createTemplate() {
        let $this = this;
        $('body').on('click', '#chat-messages #create-template', function(e) {
            e.preventDefault();

            let form = $('#chat-messages #new-template')[0];
            $.ajax({
                type: 'POST',
                url: '/cockpit/org-create-template',
                data: new FormData(form),
                processData: false,
                contentType: false,
                success: function (response) {
                    $('#chat-messages #create-template-message-modal').modal('hide');
                    $this.getTemplates();
                },
                error: function (response) {
                    let err = response.responseJSON.errors;
                    errors.showAlerts(err);
                },
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        });
    },
    saveTemplate() {
        let $this = this;
        $('body').on('click', '#chat-messages #save-template', function(e) {
            e.preventDefault();
            let form = $('#chat-messages #edit-template')[0];
            $.ajax({
                type: 'POST',
                url: '/cockpit/org-save-template',
                data: new FormData(form),
                processData: false,
                contentType: false,
                success: function (response) {
                    $('#chat-messages #edit-template-message-modal').modal('hide');
                    $this.getTemplates();
                },
                error: function (response) {
                    let err = response.responseJSON.errors;
                    errors.showAlerts(err);
                },
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });

        });
    },
    getEditTemplateModal() {
        $('body').on('click', '#chat-messages .edit-template', function(e) {
            $('#template-messages-modal').modal('hide');
            $.ajax({
                type: 'GET',
                url: '/cockpit/org-edit-template',
                data: ({
                    id: $(this).data('id'),
                }),
                success: function (response) {
                    $('#chat-messages #edit-template-outer').html(response);
                    $('#chat-messages #edit-template-message-modal').modal('show');
                },
                error: function (response) {
                    let err = response.responseJSON.errors;
                    errors.showAlerts(err);
                },
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        });
    },
    insertTemplate() {
        $('body').on('click', '#chat-messages .insert-template', function(e) {
            e.preventDefault();
            $('#chat-messages #message').val($(this).text().trim());
            $('#template-messages-modal').modal('hide');
        });
    },
    deleteTemplate() {
        let $this = this;
        $('body').on('click', '#chat-messages #delete-template', function(e) {
            e.preventDefault();
            let id = $(this).data('id');
            if (confirm('Delete this template?')) {
                $.ajax({
                    type: 'POST',
                    url: '/cockpit/org-delete-template',
                    data: ({
                        id: id,
                    }),
                    success: function (response) {
                        $('#chat-messages #edit-template-message-modal').modal('hide');
                        $this.getTemplates();
                    },
                    error: function (response) {
                        let err = response.responseJSON.errors;
                        errors.showAlerts(err);
                    },
                }).fail(function (jqXHR, exception) {
                    if (jqXHR.status == 403) {
                        localStorage.setItem('cockpit_reload_flag', true);
                        window.location.reload();
                    }
                });
            }
        });
    },
    getFollowUpsModalAdd() {
        const $this = this;
        const sidebar = $('.right-sidebar');

        $('body').on('click', '.add-follow-up', function(e) {
            e.preventDefault();
            const customer_id = $('#send-form input[name="customer_id"]').val();
            const $modal = $('#follow_up_modal');
            $('#contact-options-modal').modal('hide');

            $modal.find('#user_id').val(customer_id);
            if (!customer_id) {
                const email = $('#send-form input[name="email"]').val();
                $modal.find('#contact').val(email || $('#send-form input[name="phone"]').val());
            }

            const form = $('#new-follow-up')[0];
            form.reset();
            $modal.find('#fid').val('');
            $modal.find('#title').text('Add');
            $modal.find('#create-follow-up').text('Add');
            $modal.find('.modal-header .inner-title').text('Add Follow-Up');

            // Проверяем ширину экрана
            if (window.innerWidth < 1024) {
                // Для мобильных устройств показываем как модальное окно
                daterangepicker.setPicker($('#follow-up-date'), 'MM/DD/YYYY h:mm A', false, true);
                $modal.modal('show');
            } else {
                $('.cockpit-wrapper').hide();
                $this.insertBackButton($modal.find('.modal-header'));
                sidebar.off('click', '.back-to-sidebar').on('click', '.back-to-sidebar', function () {
                    $this.restoreRightSidebar();
                });
                const $content = $modal.find('.modal-content').clone(true, true);
                sidebar.data('previous-content', sidebar.html());
                const wrapper = $('<div/>', { class: 'standard-modal', id: 'follow_up_modal' }).append($content);
                sidebar.empty().append(wrapper);

                // Инициализируем датапикер ПОСЛЕ перемещения в сайдбар
                daterangepicker.setPicker(sidebar.find('#follow-up-date'), 'MM/DD/YYYY h:mm A', false, true);

                $modal.modal('hide');
            }
        });
    },
    getFollowUpsModalEdit() {
        const $this = this;
        const sidebar = $('.right-sidebar');

        $('body').on('click', '.edit-follow-up', function(e) {
            e.preventDefault();
            let id = $(this).data('follow_up_id');
            $.ajax({
                type: 'GET',
                url: '/cockpit/get-follow-up',
                data: ({
                    id: id,
                }),
                success: function (response) {
                    const $modal = $('#follow_up_modal');

                    $modal.find('#title').text('Edit');
                    $modal.find('#create-follow-up').text('Save');
                    $modal.find('#fid').val(id);
                    $modal.find('#user_id').val(response.message.user_id);
                    $modal.find('#contact').val(response.message.contact);
                    $modal.find('#follow-up-comment').val(response.message.comment);
                    $modal.find('#follow-up-date').val(response.message.time);
                    $modal.find('.modal-header .inner-title').text('Edit Follow-Up');

                    // Проверяем ширину экрана
                    if (window.innerWidth < 1024) {
                        // Для мобильных устройств показываем как модальное окно
                        daterangepicker.setPicker($('#follow-up-date'), 'MM/DD/YYYY h:mm A', false, true);
                        $modal.modal('show');
                    } else {
                        $('.cockpit-wrapper').hide()
                        $this.insertBackButton($modal.find('.modal-header'));
                        sidebar.off('click', '.back-to-sidebar').on('click', '.back-to-sidebar', function () {
                            $this.restoreRightSidebar();
                        });
                        const $content = $modal.find('.modal-content').clone(true, true);
                        sidebar.data('previous-content', sidebar.html());
                        const wrapper = $('<div/>', { class: 'standard-modal', id: 'follow_up_modal' }).append($content);
                        sidebar.empty().append(wrapper);

                        // Инициализируем датапикер ПОСЛЕ перемещения в сайдбар
                        daterangepicker.setPicker(sidebar.find('#follow-up-date'), 'MM/DD/YYYY h:mm A', false, true);
                        // И устанавливаем значение в уже перемещенный элемент
                        sidebar.find('#follow-up-date').val(response.message.time);

                        $modal.modal('hide');
                    }
                },
                error: function (response) {
                    console.error('Error fetching follow-up data:', response);
                },
                complete: function (response) {
                    // Handle completion if needed
                },
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        });
    },
    createFollowUp() {
        let $this = this;
        $('body').on('click', '#follow_up_modal #create-follow-up', function(e) {
            e.preventDefault();

            let user_id = $('#follow_up_modal #user_id');
            if (user_id.val().length <= 0)  user_id.prop('disabled', true);
            let contact = $('#follow_up_modal #contact');
            if (contact.val().length <= 0)  contact.prop('disabled', true);
            let fid = $('#follow_up_modal #fid');
            let url = '';
            if (fid.val()) {
                url = '/cockpit/edit-follow-up';
            }else{
                url = '/cockpit/create-follow-up';
            }

            let form = $('#new-follow-up')[0];
            $.ajax({
                type: 'POST',
                url: url,
                data: new FormData(form),
                processData: false,
                contentType: false,
                success: function (response) {
                    $('#follow_up_modal').modal('hide');
                    form.reset();
                    $this.replaceFollowUps();
                    $this.restoreRightSidebar();
                },
                error: function (response) {

                },
                complete: function (response) {
                    user_id.prop('disabled', false)
                    contact.prop('disabled', false)
                },
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        });
    },
    showConnectPad() {
        $('body').on('click', '.show-connect-pad', function(e) {
            e.preventDefault();
            $('#connect-pad-modal #connect-email').val('');
            $('#connect-pad-modal #connect-phone').val('');
            $("#connect-phone").mask("000-000-0000");
            $('#connect-phone').off('paste').on('paste', function(e) {
                e.preventDefault();
                let pastedData = e.originalEvent.clipboardData.getData('Text');
                let digits = pastedData.replace(/\D/g, '');
                if (digits.length > 10) {
                    digits = digits.slice(-10);
                }
                $(this).val(digits);
                $(this).trigger('input');
            });
            $('#connect-pad-modal').modal('show');
        });
    },
    checkUser() {
        let $this = this;
        $('body').on('click', '#connect-chat', function(e) {

            e.preventDefault();

            let id;
            if ($('#connect-pad-modal #connect-email').val().length) {
                id = 'email-' + $('#connect-pad-modal #connect-email').val();
            } else {
                id = 'phone-' + $('#connect-pad-modal #connect-phone').val();
                if ($('#connect-pad-modal #connect-phone').val().length <= 3) {
                    window.location.replace('/cockpit');
                    return;
                }
            }
            id = id.replace (/\s/g, "");

            $.ajax({
                type: 'POST',
                url: '/cockpit/org-check-get-user/' + window.organisation_id,
                data: ({
                    id: id,
                }),
                success: function (response) {
                    $('#send-form').removeClass('d-none');
                    $('#connect-pad-modal').data('id', id);
                    $('#connect-pad-modal').data('user_email', response.email);
                    $('#connect-pad-modal').data('user_phone', response.phone);
                    if (response.id) {
                        id = response.id;
                        $("input[name=customer_id]").val(id);
                    }else{
                        $("input[name=customer_id]").val('');
                    }
                    history.pushState(null, null, '/cockpit/' + id);
                    $this.replaceCurrentUser('#connect-pad-modal', response);
                    $('#connect-pad-modal').modal('hide');
                },
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });

        });
    },
    blockContact() {
        $('body').on('click', '#block-contact', function (e) {
            e.preventDefault();
            let id = $('.user_data').data('id');
            let phone = $('.user_data').data('user_phone');
            let email = $('.user_data').data('user_email');
            let blocked = $('#block-contact').data('blocked') == "1" ? 0 : 1;

            $.ajax({
                type: 'POST',
                url: '/org-block-contact',
                data: ({
                    id: id,
                    phone: phone,
                    email: email,
                    blocked: blocked,
                }),
                success: function (response) {
                    $('#block-contact').data('blocked', response.blocked);
                    $('#block-contact').toggleClass(['btn-outline-primary', 'btn-primary']);
                    $('#block-contact').text(response.blocked == "1" ? 'Unblock Contact' : 'Block Contact');
                },
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });

        });
    },
    markAsSpam() {
        let $this = this;
        $('body').on('click', '#mark-spam-contact', function (e) {
            e.preventDefault();
            let phone = $('.user_data').data('user_phone');
            let email = $('.user_data').data('user_email');
            const button = $('#mark-spam-contact');
            const currentSpam = [true, 1, '1'].includes(button.data('is_spam'));
            const is_spam = currentSpam ? 0 : 1;

            $.ajax({
                type: 'POST',
                url: '/cockpit/mark-contact-spam',
                data: ({
                    contact: [phone, email],
                    is_spam: is_spam,
                }),
                success: function (response) {
                    const updatedSpam = $this.syncSpamContactButton(response.is_spam);

                    if (updatedSpam === 0 && $('#select-spam').is(':checked')) {
                        $('#contact-options-modal').modal('hide');
                    }

                    $this.getUsers();
                },
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        });
    },
    markAsLead() {
        $('body').on('click', '.mark_as_lead', function(e) {

            e.preventDefault();

            // let id    = $('.user_data').data('id');
            let phone = $('.user_data').data('user_phone');
            let email = $('.user_data').data('user_email');
            // let mark_as_lead = $('.mark_as_lead').data('lead') == "1" ? 0 : 1;

            let timestamp = Math.floor(Date.now() / 1000)
            let randomValue = ('00' + Math.floor((Math.random() * 1000))).slice(-3);
            let uid = timestamp + '' + randomValue

            let sendingData = {
                'uid': uid,
                'phone': phone,
                'email': email,
                'source': 'cockpit'
            }

            $.post('/lead-store', sendingData, function (response) {
                console.log('send lead cockpit: ', sendingData, response);
                if(response.success) {
                    $('.mark_as_lead').data('lead', 1);
                    $('.mark_as_lead').removeClass('btn-outline-primary').addClass('btn-primary');
                } else {
                    $('.mark_as_lead').data('lead', 0);
                    $('.mark_as_lead').removeClass('btn-primary').addClass('btn-outline-primary');
                }
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });

        });
    },
    messagesSettingsModal() {
        $('body').on('click', '.messages_settings', function(e) {
            $('.form-validation-errors').html('');
            $('.form-validation-errors').removeClass(['alert', 'alert-success']);
            $('#messages_settings_modal').modal('show');
        });
    },
    breakEmailChain() {
        $('body').on('click', '#messages_settings_modal #break_email_chain', function(e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/cockpit/org-break-email-chain',
                data: ({
                    email: $('#send-form input[name="email"]').val()
                }),
                success: function (response) {
                    $('.form-validation-errors').addClass(['alert', 'alert-success']);
                    $('.form-validation-errors').html(response.message);
                    setTimeout(function() {
                        $('#messages_settings_modal').modal('hide');
                    }, 2000);
                },
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });
        });
    },
    showForwardButtons() {
        $('body').on('click', '.forwards, .js-event-menu', function (e) {
            e.preventDefault();
            e.stopPropagation();

            let id = $(this).data('forward');
            let menu = $('#forward-' + id);
            let willOpen = menu.hasClass('d-none');

            $('.event-actions-menu').not(menu).addClass('d-none').removeClass('d-flex');
            menu.toggleClass('d-none', !willOpen).toggleClass('d-flex', willOpen);
            $(this).attr('aria-expanded', willOpen ? 'true' : 'false');
        });
    },

    enterDialPadNumber(){
        $('.dialpad-buttons .dialpad_btn').click(function() {
            //$('.dialpad-history').append($(this).data('value'));
            let newValue = $('#dilpad-code').val() + $(this).data('value')
            $('#dilpad-code').val(newValue);
            $('.dialpad_btn').removeClass('clicked');
            $(this).addClass('clicked');
        });

        $('#dialpad-backspace-button').click(function(e) {
            e.preventDefault();
            let value = $('#dilpad-code').val();
            $('#dilpad-code').val(value.substring(0,value.length-1));
        });

        $('body').on('click', '.show_dialpad', function(e) {
            $("#call_dialpad_modal").modal('show');
        });

        $('body').on('click', '.end-call', function() {
            $('.dialpad-history').text('');
        });
    },
    getEmailAdditionalInfoModal(){
        $('body').on('click', '.message-content .additional-email', (e)=>{
            $.ajax({
                method: 'POST',
                url: '/cockpit/get-email-additioanl-info',
                data: {id: $(e.target).data('id')},
                success: (response)=>{
                    $('#form-container').html(response);
                    $('#email-additional-info-modal').modal('show');
                },
                error: (response)=> {

                }
            });
        });
    },

    trackCreateIncidentModal() {
        const sidebar = $('.right-sidebar');
        const $this = this;
        let isProcessing = false; // Flag to prevent infinite loop

        // Create a MutationObserver to watch for the modal appearance
        const observerCreateIncidentModal = new MutationObserver(function(mutations) {
            // If already processing, skip to prevent infinite loop
            if (isProcessing) return;

            mutations.forEach(function(mutation) {
                // Check if nodes were added
                mutation.addedNodes.forEach(function(node) {
                    // Check if the added node is an element and has the target modal
                    // Also check that it's not already in the sidebar to prevent recursion
                    if (node.nodeType === 1 && node.id === 'create-incident-modal' && !$(node).closest('.right-sidebar').length) {
                        // Set processing flag to prevent recursion
                        isProcessing = true;

                        $('.modal-backdrop').remove()
                        $(node).removeClass('fade');
                        $(node).find('.standart-close-btn').remove() // scoped: was stripping every modal's close X

                        // Modal appeared, check screen width to determine behavior
                        const $modal = $(node);
                        const $modalContent = $modal.find('.modal-content');

                        if ($modalContent.length) {
                            // Проверяем ширину экрана
                            if (window.innerWidth < 1024) {
                                // Для мобильных устройств показываем как модальное окно
                                $('body').append($modal);
                                $modal.addClass('fade').modal('show');
                            } else {
                                $('.cockpit-wrapper').hide()
                                sidebar.data('previous-content', sidebar.html());

                                const clonedContent = $modalContent.clone(true, true);
                                const header = clonedContent.find('.modal-header').first();

                                if (header.length) {
                                    $this.insertBackButton(header);
                                }

                                const wrapper = $('<div/>', {
                                    class: 'standard-modal',
                                    id: 'create-incident-modal'
                                }).append(clonedContent);

                                sidebar.empty().append(wrapper);

                                sidebar.off('click', '.back-to-sidebar').on('click', '.back-to-sidebar', function () {
                                    $this.restoreRightSidebar();
                                });

                                // Completely remove the original modal to prevent it from showing
                                $modal.remove();
                            }
                        }

                        // Reset processing flag after a short delay
                        setTimeout(() => {
                            isProcessing = false;
                        }, 100);
                    }
                });
            });
        });

        // Start observing the document body for changes
        observerCreateIncidentModal.observe(document.body, {
            childList: true,
            subtree: true
        });
    },

    trackEditIncidentModal() {
        const sidebar = $('.right-sidebar');
        const $this = this;
        let isProcessing = false; // Flag to prevent infinite loop

        // Create a MutationObserver to watch for the modal appearance
        const observerEditIncidentModal = new MutationObserver(function(mutations) {
            // If already processing, skip to prevent infinite loop
            if (isProcessing) return;

            mutations.forEach(function(mutation) {
                // Check if nodes were added
                mutation.addedNodes.forEach(function(node) {
                    // Check if the added node is an element and has the target modal
                    // Also check that it's not already in the sidebar to prevent recursion
                    if (node.nodeType === 1 && node.id === 'edit-incident-modal' && !$(node).closest('.right-sidebar').length) {
                        // Set processing flag to prevent recursion
                        isProcessing = true;

                        $('.modal-backdrop').remove()
                        $(node).removeClass('fade');
                        $(node).find('.standart-close-btn').remove() // scoped: was stripping every modal's close X

                        // Modal appeared, check screen width to determine behavior
                        const $modal = $(node);
                        const $modalContent = $modal.find('.modal-content');

                        if ($modalContent.length) {
                            // Проверяем ширину экрана
                            if (window.innerWidth < 1024) {
                                // Для мобильных устройств показываем как модальное окно
                                $('body').append($modal);
                                $modal.addClass('fade').modal('show');
                            } else {
                                $('.cockpit-wrapper').hide()
                                sidebar.data('previous-content', sidebar.html());

                                const clonedContent = $modalContent.clone(true, true);
                                const header = clonedContent.find('.modal-header').first();

                                if (header.length) {
                                    $this.insertBackButton(header);
                                }

                                const wrapper = $('<div/>', {
                                    class: 'standard-modal',
                                    id: 'edit-incident-modal'
                                }).append(clonedContent);

                                sidebar.empty().append(wrapper);

                                sidebar.off('click', '.back-to-sidebar').on('click', '.back-to-sidebar', function () {
                                    $this.restoreRightSidebar();
                                });

                                // Completely remove the original modal to prevent it from showing
                                $modal.remove();
                            }
                        }

                        // Reset processing flag after a short delay
                        setTimeout(() => {
                            isProcessing = false;
                        }, 100);
                    }
                });
            });
        });

        // Start observing the document body for changes
        observerEditIncidentModal.observe(document.body, {
            childList: true,
            subtree: true
        });
    },
    showCarbonCopiesModal(){
        $('.show-cc-modal').click((e)=>{
            $('#carbon_copies_modal').modal('show');
        });

        $('.save_carbon_copies_list').click((e)=>{
            let text = $('#cc_email_list').val();
            let list = text.split(/,?\s|,/);
            let validated_list = this.validateEmails(list);
            let json = JSON.stringify(validated_list);
            $('#cc_list').val(json);
            $('.cc-count').text('('+validated_list.length+')');

            $('#carbon_copies_modal').modal('hide');
        });
    },
    clearCCForm(){
        $('.cc-count').text('');
        $('#cc_email_list').val('');
        $('#cc_list').val('');
    },
    validateEmails(emails){
        const re = new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/);

        let validated_emails = [];
        emails.forEach(email => {
            console.log(re.test(email), email, emails.indexOf(email));
            if (re.test(email) == true) {
                validated_emails.push(email);
            }
        });
        return validated_emails;
    },

    numpadInit(){
        window.addEventListener('keydown', ev=>{
            if(!$('.modal-form-numpad.show').length)
                return
            if($(`#quick-connect-form .numpad-button[data-value="${ev.key}"]`).length)
                $(`#quick-connect-form .numpad-button[data-value="${ev.key}"]`).trigger('click')
            else if(ev.key == 'Backspace')
                $(`#quick-connect-form .backspace-button`).trigger('click')
        })

        $('#quick-connect-form #numpad-input').val(this.numValue)

        $('#quick-connect-form .numpad-button, #quick-connect-form .backspace-button').on('click',ev=>{
            if($(ev.currentTarget).data('value')===null || $(ev.currentTarget).data('value')===undefined)
                return
            let slice = this.numValue[this.numValue.length-1]=='-' ? 2 : 1
            const num = $(ev.currentTarget).data('value');
            let newValue = num==-1
                ? (this.numValue.length>3 ? this.numValue.slice(0,this.numValue.length-slice) : this.numValue)
                : (this.numValue.length+1>15 ? this.numValue : this.numValue+num)
            newValue = newValue.replace(/(\+1)\s*([0-9\*\#]{3})?[\s\-]*([0-9\*\#]{3})?[\s\-]*([0-9\*\#]{4})?/,
                (match,fr,tw,tr,fo)=>`${fr} `+(tw ? tw+'-':'')+(tr ? tr+'-':'')+(fo ?? ''))
            if(newValue != this.numValue){
                this.numValue = newValue
                $('#quick-connect-form #numpad-input').val(this.numValue)
            }
        })

        $('#quick-connect-form #quick-call-numpad-btn').on('click', ev=> {
            if(this.numValue.length<14 || !/^\+1\s+([0-9\*\#]{3})?[\s\-]+([0-9\*\#]{3})?[\s\-]+([0-9\*\#]{4})?/.test(this.numValue)){
                $('#quick-connect-form .text-danger').removeClass('d-none')
                setTimeout(()=>$('#quick-connect-form .text-danger').addClass('d-none'),3000)
                return
            }
            let id = 'phone-' + this.numValue.substring(3);
            console.log('ID:', id)
            id = id.replace (/\s/g, "");
            $.ajax({
                type: 'POST',
                url: '/cockpit/org-check-get-user/' + window.organisation_id,
                data: ({
                    id: id,
                }),
                success: response => {
                    $('#send-form').removeClass('d-none');
                    $('#quick-call-modal').data('id', id);
                    $('#quick-call-modal').data('user_email', response.email);
                    $('#quick-call-modal').data('user_phone', response.phone);
                    if (response.id) {
                        id = response.id;
                        $("input[name=customer_id]").val(id);
                    }else{
                        $("input[name=customer_id]").val('');
                    }
                    history.pushState(null, null, '/cockpit/' + id);
                    this.replaceCurrentUser('#quick-call-modal', response);
                    $('#quick-call-modal').modal('hide');
                    $('.cockpit-buttons #call').trigger('click')
                    setTimeout(()=>{
                        $('#user_call_modal .wait-call').trigger('click')
                    },2000)
                },
            }).fail(function (jqXHR, exception) {
                if (jqXHR.status == 403) {
                    localStorage.setItem('cockpit_reload_flag', true);
                    window.location.reload();
                }
            });

        });
    },

    newJobRequest(){
        $('body').off('click', '#add-jobs')
        .on('click', '#add-jobs', ()=>{
            const staticRequest = new JobRequest();
            staticRequest.openModal('create');
        })
    },
    
    spamConversationContextMenu(){
        const menu = $('#spam-conversation-context-menu');

        if (!menu.length) {
            return;
        }

        const hideMenu = () => {
            menu.addClass('d-none')
                .removeClass('d-flex')
                .attr('aria-hidden', 'true');
        };

        const openMenu = (row, clientX, clientY) => {
            const messageId = row.data('suspected-message-id');
            if (!messageId) {
                return;
            }

            const deleteButton = menu.find('.js-delete-suspected-conversation');
            deleteButton.attr('id', 'del-' + messageId);

            menu.removeClass('d-none')
                .addClass('d-flex')
                .attr('aria-hidden', 'false');

            const bounds = menu[0].getBoundingClientRect();
            const left = Math.max(8, Math.min(clientX, window.innerWidth - bounds.width - 8));
            const top = Math.max(8, Math.min(clientY, window.innerHeight - bounds.height - 8));
            menu.css({ left: left + 'px', top: top + 'px' });
            deleteButton.trigger('focus');
        };

        $('body').on('contextmenu', '.js-suspected-spam-conversation', function (event) {
            event.preventDefault();
            openMenu($(event.currentTarget), event.clientX, event.clientY);
        });

        $('body').on('keydown', '.js-suspected-spam-conversation', function (event) {
            if (event.key !== 'ContextMenu' && !(event.shiftKey && event.key === 'F10')) {
                return;
            }

            event.preventDefault();
            const bounds = event.currentTarget.getBoundingClientRect();
            openMenu($(event.currentTarget), bounds.left + 16, bounds.top + 16);
        });

        $('body').on('click', function (event) {
            if (!$(event.target).closest('#spam-conversation-context-menu').length) {
                hideMenu();
            }
        });
        $('body').on('click', '#spam-conversation-context-menu .js-delete-suspected-conversation', hideMenu);
        $('body').on('keydown', function (event) {
            if (event.key === 'Escape') {
                hideMenu();
            }
        });
        $(window).on('resize scroll', hideMenu);
    },

    spamReview(){
        $('body').on('click', '.js-spam-review-trigger', function (event) {
            event.preventDefault();
            event.stopPropagation();

            const trigger = $(event.currentTarget);
            const modal = $('#spam-review-modal');
            modal.data('message-id', trigger.data('message-id'));
            $('#spam-review-score').text(Number(trigger.data('spam-score')).toFixed(1));
            $('#spam-review-source').text(
                trigger.data('spam-sender') + ' · “' + trigger.data('spam-subject') + '”'
            );
            $('#spam-review-error').addClass('d-none');
            modal.modal('show');
        });

        $('body').on('click', '.js-spam-review-decision', function (event) {
            event.preventDefault();

            const button = $(event.currentTarget);
            const modal = $('#spam-review-modal');
            const buttons = modal.find('.js-spam-review-decision');
            buttons.prop('disabled', true);
            button.addClass('is-loading');
            $('#spam-review-error').addClass('d-none');

            $.ajax({
                type: 'POST',
                url: '/cockpit/review_spam',
                data: {
                    id: modal.data('message-id'),
                    decision: button.data('decision'),
                },
                success: function () {
                    modal.modal('hide');
                    window.location.reload();
                },
                error: function () {
                    $('#spam-review-error').removeClass('d-none');
                    buttons.prop('disabled', false);
                    button.removeClass('is-loading');
                },
            });
        });
    },

    markSpamMessage(){
        $('body').on('click', '.mark-spam', (e)=>{
            e.preventDefault();
            const button = $(e.currentTarget);
            $.ajax({
                type: 'POST',
                url: '/cockpit/mark_spam',
                data: ({
                    ids: [$(e.currentTarget).data('message_id')],
                }),
                success: function (response) {
                    const key = 'message_' + button.data('message_id');
                    button.text(response.is_spam[key] ? 'Remove spam mark' : 'Mark as spam');
                    window.location.reload();
                },
            });
        });
    }
}
